var Marionette = require('backbone.marionette');

var Radio = require('backbone.radio');
var notificationsChannel = Radio.channel('notifications');
var actionsChannel = Radio.channel('actions');

var CommonUtils = require('../../utils/common-utils.js');
var Constants = require('../../utils/constants');

var SendDocumentForm = Marionette.View.extend({
    template: require('../../templates/documents/send-document-form.html'),

    ui: {
        modal: '#send-document-modal',
        comment: '#comment',
        commentSource: "#comment-source",
        commentIsInternal: "#is-internal",
        checkDocument: '#check-document',
        checkPhysician: '#check-physician',
        checkOrganization: '#check-organization',
        checkPatient: '#check-patient',
        send: '#send-document',
        sendDocumentConfirm: '#send-document-confirm',
        sendFormBody: '#send-form-body',
        sendConfirmationBody: '#send-confirmation-body',
        sendFooter: '#send-footer',
        confirmationFooter: '#confirmation-footer',
        additionalSendConfirmationBody: '#additional-send-confirmation-body',
        additionalSendDocumentConfirm: '#additional-send-document-confirm',
        additionalConfirmationFooter: '#additional-confirmation-footer'

    },

    events: {
        'click @ui.send': 'onSend',
        'click @ui.sendDocumentConfirm': 'onSendCheckMoreThatLimitConfirm',
        'keyup @ui.comment': 'onCommentChanged',
        'change @ui.commentSource': 'onChangeCommentSource',
        'change @ui.commentIsInternal': 'onChangeCommentIsInternal',
        'change @ui.checkDocument': 'onCheckDocument',
        'change @ui.checkPhysician': 'onCheckPhysician',
        'change @ui.checkOrganization': 'onCheckOrganization',
        'change @ui.checkPatient': 'onCheckPatient',
        'click @ui.additionalSendDocumentConfirm': 'onSendNoConfirm'
    },

    initialize: function (options) {
        var that = this;
        that.utils = new CommonUtils();
        that.allFiltered = options.allFiltered || false;
        that.params = options.params || "";
        if (that.allFiltered) {
            that.url = '/api/document/send/filtered?' + that.params;
        } else {
            that.url = '/api/document/send/documents';
        }
        that.documentsComment = {
            comment: {
                text: undefined,
                source: 'FRONTPAGE',
                internal: false
            },
            commentDocument: true,
            commentReviewerPerson: true,
            commentReviewerOrganization: true,
            commentPatient: true,
            documentIds: options.docIds
        };
        that.docsCount = options.docsCount || 0;
        that.docsCount = that.allFiltered ? that.docsCount : (that.documentsComment.documentIds || []).length;
    },

    templateContext: function () {
        var that = this;
        return {
            docsCount: that.docsCount
        }
    },

    onRender: function () {
        this.show();
    },

    onSend: function () {
        var that = this;
        if ((that.documentsComment.documentIds == [] || _.isEmpty(that.documentsComment.documentIds)) && !that.allFiltered)
            return;

        if (that.docsCount > Constants.pageCapacity) {
            that.ui.sendFormBody.hide();
            that.ui.sendFooter.hide();
            that.ui.sendConfirmationBody.show();
            that.ui.confirmationFooter.show();
        } else {
            that.onSendNoConfirm();
        }
    },

    onSendNoConfirm: function () {
        var that = this;
        that.utils.showSpinner("#send-document-loader");
        $.ajax({
            type: "POST",
            url: that.url,
            data: JSON.stringify(that.documentsComment),
            contentType: 'application/json',
            statusCode: {
                200: function (response) {
                    that.utils.hideSpinner("#send-document-loader");
                    that.hide();
                    $.notify({
                        message: 'Selected documents sent successfully'
                    }, {
                        type: 'success',
                        z_index: 2000,
                    });
                    if (that.getOption("woResponseEvent") !== true)
                        that.triggerMethod('sent:document');
                }
            },
            error: function (e) {
                that.utils.hideSpinner("#send-document-loader");
                if (e.status == 401) {
                    actionsChannel.request("redirect:to:login");
                } else {
                    notificationsChannel.request('show:notification', JSON.parse(e.responseText));
                }
            }
        });
    },
    onSendCheckMoreThatLimitConfirm: function () {
        var that = this;
        if ((that.documentsComment.documentIds == [] || _.isEmpty(that.documentsComment.documentIds)) && !that.allFiltered)
            return;

        if (that.docsCount > Constants.maxDocumentsForEndingWOConfirmation) {
            that.ui.sendConfirmationBody.hide();
            that.ui.confirmationFooter.hide();
            that.ui.additionalConfirmationFooter.show();
            that.ui.additionalSendConfirmationBody.show();
        } else {
            that.onSendNoConfirm();
        }
    },

    show: function () {
        this.ui.modal.modal({backdrop: 'static', keyboard: false});
    },

    hide: function () {
        this.ui.modal.modal('hide');
    },

    onCommentChanged: function (event) {
        this.documentsComment.comment.text = event.target.value;
    },

    onChangeCommentSource: function (e) {
        this.documentsComment.comment.source = e.target.value;
    },

    onChangeCommentIsInternal: function (e) {
        this.documentsComment.comment.internal = e.target.checked;
    },

    onCheckDocument: function (event) {
        this.documentsComment.commentDocument = event.target.checked;
    },

    onCheckPhysician: function (event) {
        this.documentsComment.commentReviewerPerson = event.target.checked;
    },

    onCheckOrganization: function (event) {
        this.documentsComment.commentReviewerOrganization = event.target.checked;
    },

    onCheckPatient: function (event) {
        this.documentsComment.commentPatient = event.target.checked;
    }
});

module.exports = SendDocumentForm;


//////////////////
// WEBPACK FOOTER
// ./app/views/documents/send-document-form.js
// module id = 324
// module chunks = 0